import { render, staticRenderFns } from "./character_selector_button.vue?vue&type=template&id=5dd47766&scoped=true&"
import script from "./character_selector_button.vue?vue&type=script&lang=js&"
export * from "./character_selector_button.vue?vue&type=script&lang=js&"
import style0 from "./character_selector_button.vue?vue&type=style&index=0&id=5dd47766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd47766",
  null
  
)

export default component.exports